export default __webpack_public_path__ + "3b12626e50d4130de68ecdc161029609.png";